/**
 * OOI-specific experiments should be listed here.
 * scope: viewer-apps-14bcded7-0066-7c35-14d7-466cb3f09103
 */
export const OOI_EXPERIMENTS = {
  /**
   * https://bo.wix.com/guineapig/experiments/3508196
   */
  INSTALL_SEARCH: 'specs.wixBlog.InstallSearch',
  /**
   * https://bo.wix.com/guineapig/experiments/3627662
   */
  USE_PLATFORM_API: 'specs.wixBlog.migratedToNewPlatformApi',
  /** https://bo.wix.com/guineapig/experiments/2999137 */
  MANAGE_POSTS_NAVIGATE_TO_POSTS: 'specs.wixBlog.ManagePostsNavigateToPosts',
  /**
   * - Users: TBD
   * - Employees: https://bo.wix.com/guineapig/experiments/4267517
   **/
  OPTIMIZE_READ_TIME_BI_EVENT: 'specs.wixBlog.OptimizeReadTimeBiEvent',
  /**
   * Enable Header Image in the post composer
   * https://bo.wix.com/guineapig/experiments/4253060
   */
  HEADER_IMAGE: 'specs.wixBlog.HeaderImage',
  /**
   * Does not allow to install blog members area apps in the editor.
   * https://bo.wix.com/guineapig/experiments/4288493
   */
  DONT_REGISTER_MEMBER_PAGES: 'specs.wixBlog.DontRegisterMemberPages',
};
